import 'react';
import { Backdrop, Portal } from '@mui/material';

export interface OverlayMaskProps {
  open: boolean;
  onClick?: () => void;
  // When true, clicking the backdrop will trigger onClick. Default false to prevent closing via blank area.
  clickable?: boolean;
}

/**
 * A single global-like overlay mask rendered via Portal.
 * Place this once at the top-level where coordinated overlays are needed.
 */
export function OverlayMask({ open, onClick, clickable = false }: OverlayMaskProps) {
  return (
    <Portal>
      <Backdrop
        open={open}
        onClick={clickable ? onClick : undefined}
        sx={(theme) => ({ zIndex: theme.zIndex.modal - 1, color: '#fff' })}
      />
    </Portal>
  );
}
